import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=8a4ea9fc&scoped=true"
import script from "./UserAdd.vue?vue&type=script&lang=js"
export * from "./UserAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4ea9fc",
  null
  
)

export default component.exports